import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { Col, Divider } from "antd";
import { pixelTheme } from '../../theme/pixelTheme';

export const Footer = styled.footer`
  background: ${pixelTheme.colors.dark};
  padding: 0.5rem 0 1rem;
  margin-top: auto;
  width: 100%;
  border-top: 4px solid ${pixelTheme.colors.primary};
  box-shadow: 0 -4px 0 0 rgba(0,0,0,0.3);
  position: relative;
  
  &:before {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: 2px;
    background: repeating-linear-gradient(
      90deg,
      ${pixelTheme.colors.accent} 0px,
      ${pixelTheme.colors.accent} 10px,
      transparent 10px,
      transparent 20px
    );
  }
`;

export const Title = styled.h4`
  font-family: 'Pixelify Sans', monospace;
  font-size: 16px;
  font-weight: 700;
  text-transform: uppercase;
  color: ${pixelTheme.colors.light};
  letter-spacing: 2px;
  text-shadow: 2px 2px 0 rgba(99, 102, 241, 0.1);

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
    font-size: 10px;
  }
`;

export const NavLink = styled(Link)`
  display: block;
  font-family: 'Pixelify Sans', monospace;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 0.625rem;
  transition: all 0.1s steps(3);
  color: ${pixelTheme.colors.light};
  position: relative;
  padding-left: 12px;
  
  &:before {
    content: '▸';
    position: absolute;
    left: 0;
    opacity: 0;
  }
  
  &:hover,
  &:active,
  &:focus {
    color: ${pixelTheme.colors.accent};
    transform: translateX(5px);
    
    &:before {
      opacity: 1;
      animation: blink 0.5s infinite;
    }
  }
`;

export const Target = styled.a`
  display: block;
  font-family: 'Pixelify Sans', monospace;
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 0.625rem;
  transition: all 0.1s steps(3);
  color: ${pixelTheme.colors.light};
  position: relative;
  padding-left: 12px;
  
  &:before {
    content: '▸';
    position: absolute;
    left: 0;
    opacity: 0;
  }

  &:hover,
  &:active,
  &:focus {
    color: ${pixelTheme.colors.accent};
    transform: translateX(5px);
    
    &:before {
      opacity: 1;
      animation: blink 0.5s infinite;
    }
  }
`;

export const Extra = styled.section`
  background: rgb(249, 250, 252);
  position: relative;
  width: 100%;
  padding-right: 25px;
  padding-left: 25px;
  margin-right: auto;
  margin-left: auto;
  padding-bottom: 2rem;
`;

export const LogoContainer = styled.div`
  display: flex;
  position: relative;
`;

export const Select = styled.div`
  line-height: 24px;

  @media only screen and (min-width: 1024px) {
    padding: 0 10%;
  }
`;

export const Para = styled.div`
  color: ${pixelTheme.colors.light};
  max-width: 340px;
  font-family: 'Pixelify Sans', monospace;
  font-size: 16px;
  font-weight: 500;
  width: 100%;
  letter-spacing: 0.5px;
`;

export const CopyRightPara = styled.div`
  color: ${pixelTheme.colors.light};
  font-family: 'Pixelify Sans', monospace;
  font-size: 9px;
  width: 100%;
  text-align: center;
  opacity: 0.7;
  letter-spacing: 1px;
  text-transform: uppercase;
`;

export const Large = styled.p`
  font-family: 'Pixelify Sans', monospace;
  font-size: 16px;
  font-weight: 500;
  color: ${pixelTheme.colors.primary};
  text-align: ${(props) => (props.left ? 'left' : '')};
  padding: ${(props) => (props.left ? '0 10%' : '')};
  cursor: pointer;
  transition: all 0.1s steps(3);
  text-transform: uppercase;
  line-height: 24px;
  display: inline-block;
  margin-bottom: 0.625rem;
  margin-top: 0.5rem;
  letter-spacing: 1px;
  
  &:hover {
    color: ${pixelTheme.colors.accent};
    text-shadow: 0 0 8px rgba(245, 158, 11, 0.4);
  }
`;

export const Chat = styled.p`
  color: ${pixelTheme.colors.light};
  font-family: 'Pixelify Sans', monospace;
  font-size: 11px;
  font-weight: normal;
  max-width: 90px;
  border-bottom: 2px solid ${pixelTheme.colors.border};
  cursor: pointer;
  margin-top: 1rem;
  text-transform: uppercase;
  letter-spacing: 1px;
  transition: all 0.1s steps(3);

  &:hover {
    border-bottom: 2px solid ${pixelTheme.colors.accent};
    color: ${pixelTheme.colors.accent};
    transform: scale(1.05);
  }
`;

export const Empty = styled.div`
  position: relative;
  height: 53px;
`;

export const FooterContainer = styled.div`
  max-width: 510px;
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 414px) {
    padding: 2rem 0;
    padding-right: 50%;
  }

  div {
    cursor: pointer;
    margin-right: 15px;
    width: 25px;
    height: 25px;

    &:hover {
      fill: rgb(255, 130, 92);
    }
  }
`;

export const Hidden = styled.div`
  display: contents;
  width: 100%;

  @media screen and (max-width: 414px) {
    display: none;
  }
`;

export const Language = styled.h4`
  font-size: 16px;
  text-transform: uppercase;
  color: #000;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
  }
`;

export const Label = styled.label`
  font-size: 16px;
  text-transform: uppercase;
  color: #000;
  display: block;
  margin-bottom: 2rem;

  @media screen and (max-width: 414px) {
    padding: 1.5rem 0;
    margin-bottom: 1rem;
  }
`;

export const LangSelect = styled.select`
  cursor: pointer;
  border: none;
  font-size: 1rem;
  background: rgb(249, 250, 252);
`;

export const CenterContentCol = styled(Col)`
  text-align: center;
`;

export const ColorDivider = styled(Divider)`
  border-left: 2px dashed ${pixelTheme.colors.border};
  opacity: 0.5;
`;
